import { lzIsArray } from "../services/LzType";

export default class LzOptionModel {

  constructor(model, valueField, textField, extraFields) {
    if (!model) {
      model = {};
    }

    valueField = valueField ? valueField : 'value';
    textField = textField ? textField : 'text';

    this.value = model[valueField] ? +model[valueField] : 0;
    this.text = model[textField] ? model[textField] : '';
    this.key = this.value;

    if (extraFields) {
      for (const field of extraFields) {
        this[field] = model[field] || '';
      }
    }
  }

  static parseArray(data, valueField, textField, extraFields) {
    if (!lzIsArray(data)) {
      return [];
    }

    const out = [];

    for (const item of data) {
      out.push(new LzOptionModel(item, valueField, textField, extraFields));
    }

    return out;
  }

  static parseAsIdName(data) {
    if (!lzIsArray(data)) {
      return [];
    }

    const out = [];

    for (const item of data) {
      out.push({ id: item.value, name: item.text });
    }

    return out;
  }

}
